import React, { Component } from 'react';
import '../../../src/styles/Topics.css';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import ChapterModal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import { appService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import ReactGA from 'react-ga';
let parameters = '';
var proId;
let subscribedArray = '', otherSubscribedArray = '', isSubscribe = '', subscribedData = '', unSubscribedData = '', useragent = navigator.userAgent;
var Setborder = {
    border: '1px solid #CCCCCC'
}

export class TopicDescription extends Component {
    displayName = TopicDescription.name
    constructor(props) {
        super(props);
        this.state = { //this is a temporary fix for hiding/showing links if not logged in -  condition will be modified 
            login: false,
            practiceAreaTopic: "",
            practiceAreaTitle: "",
            OnlinePrice: '',
            printedmaterial: '',
            PdfPrice: '',
            journalLink: '',
            manualLink: '',
            encycloLink: '', metaDescription: '', metaTitle: '',
            showText: false, Clicked: false, Subscribed: false,
        }
        this.state = {
            checked1: true,
            practiceAreasList: [],
            practiceAreasddlList: [],
            productprice: [], items: []
        }

        this.handleSelect = this.handleSelect.bind(this);
        this.handleChapterModalShow = this.handleChapterModalShow.bind(this);
        this.handleChapterModalClose = this.handleChapterModalClose.bind(this);
        this.changeEvent = this.changeEvent.bind(this);
        // this.changeEvent1 = this.changeEvent1.bind(this);


    }

    stingBreakLine(str, length, ending) {
        //console.log(str.length);
        if (length == null) {
            length = 30;
        }
        if (ending == null) {
            ending = '..';
        }

        if (str != null && str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    };

    getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    //Bind Change Event.
    changeEvent(e) {

        if (e.target.id > 0) {
            e.preventDefault();
            //    var index = e.nativeEvent.target.selectedIndex;
            //    //console.log(e.target);
            //    //console.log(e.nativeEvent.target[index].text.length);

            //    if (e.nativeEvent.target[index].text.length > 48) {
            //        e.target.style.padding = '5% 13% 0% 0%';
            //    }
            //    else {
            //        e.target.style.padding = '-1%';
            //    }

            // console.log(e.target.innerText);

            this.setState({ practiceAreaTitle: e.target.innerText });
            this.practiceAreaTopic = e.target.innerText;

            this.GetPracticeAreasById(e.target.id);
            window.history.pushState("", "", "/PracticeArea?Id=" + e.target.id + "&name=" + e.target.innerText.replace(/ /g, "+"))
            this.setState({ showText: !this.state.showText })
            this.setState({ Clicked: true })
            if (localStorage.getItem('user') !== null) {
                window['NTPT_PGEXTRA'] = 'Product=' + e.target.innerText + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + '' + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
            else {
                window['NTPT_PGEXTRA'] = 'Product=' + e.target.innerText + '&User= ' + '&platform=klo &useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }

            var msg = {
                ArticleTitle: window['NTPT_PGEXTRA']
            }
            var Logurl = 'Product/LogData';
            appService.submit(Logurl, msg).then(function (data) {

            });
        }

    }


    //Retrive Data By Practice Areas ById
    GetPracticeAreasById(id) {
        var self = this;
        parameters = { ProductId: id, user: JSON.parse(localStorage.getItem('user')) };
        appService.getByIssueId('Product/GetPracticeAreasById', parameters).then(function (data) {
            if (data == "Error found") {
                //window.location = "/Maintenance";;
            }
            self.setState({ practiceAreasList: data, items: data });
            data.map((Items) => {
                //console.log(Items.productPrice)
                self.setState({ productprice: Items.productPrice });
                self.setState({ Subscribed: Items.subscribed });
                if (Items.productType == 'Journal article') {
                    self.setState({ journalLink: 'Journal article' });
                }
                else if (Items.productType == 'Manual chapter') {
                    self.setState({ manualLink: 'Manual chapter' });
                }
                else if (Items.productType == 'Encyclopedia chapter') {
                    self.setState({ encycloLink: 'Encyclopedia chapter' });
                }
                self.state.productprice.map((item) => {
                    // console.log(item);
                    if (item.type == "2") {
                        self.setState({ OnlinePrice: item.euro });
                    }
                    if (item.type == "3") {
                        self.setState({ printedmaterial: item.euro });
                    }
                    if (item.type == "1") {
                        self.setState({ PdfPrice: item.euro });
                    }
                }
                )
            })
        });


    }

    componentDidMount() {
        var self = this;
        if (localStorage.getItem('user') !== null) {
            this.state.login = true;
        }
        else {
            this.state.login = false;
        }
        proId = self.getUrlVars()["Id"];
        self.GetPracticeAreasById(proId);

        appService.getAll('Product/GetAllPracticeAreas').then(function (data) {
            // console.log(data);
            if (data == "Error found") {
                //window.location = "/Maintenance";;
            }
            self.setState({ practiceAreasddlList: data });
          
            // self.setState({ practiceAreasList: data });

        });


        let titleTopic = '';
        titleTopic = decodeURI(window.location.href.slice(window.location.href.indexOf('?') + 1).split('name=')[1].replace(/\+/g, ' '));
        if (titleTopic == "undefined" || titleTopic == "") {
            self.practiceAreaTopic = '';
            self.setState({ practiceAreaTitle: '' });
        }
        else {
            self.practiceAreaTopic = titleTopic;
            self.setState({ practiceAreaTitle: titleTopic });
        }


        if (localStorage.getItem('user') !== null) {
            window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + encodeURIComponent(titleTopic) + '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + '' + '&platform=klo &useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }
        else {
            window['NTPT_PGEXTRA'] = 'event_type=Searches_Regular&keywords=' + encodeURIComponent(titleTopic) + '&User= ' + '&platform=klo &useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }

        var msg = {
            ArticleTitle: window['NTPT_PGEXTRA']
        }
        var Logurl = 'Product/LogData';
        appService.submit(Logurl, msg).then(function (data) {

        });

        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], titleTopic + " - Kluwer Law Online");
        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }
    };

    handleSelect() {
        window.scrollTo(0, 0);
    }
    handleChapterModalClose() {
        this.setState({ handleChapterModalShow: false });
    }
    handleChapterModalShow() {
        this.setState({ handleChapterModalShow: true });
    }
    render() {

        const meta = {
            title: this.practiceAreaTopic + " - Kluwer Law Online",
            // description: this.state.metaDescription,
            canonical: window.location.href,
            meta: {
                charset: "utf-8",
                name: {
                    title: this.state.metaTitle,
                    description: this.state.metaDescription
                }
            }
        }

        const onlineSubscribed = this.state.items;
        subscribedArray = onlineSubscribed.filter(item => item.subscribed == true);

        const otherSubscribed = this.state.items;
        otherSubscribedArray = otherSubscribed.filter(item => item.subscribed != true)
        if (subscribedArray.length > 0) {
            isSubscribe = 1
        }
        subscribedData = subscribedArray.map((item, key) =>

            <div className="JournalFlex SetHeightfortopic">
                {this.state.journalLink == item.productType ?

                    <Link onClick={this.handleSelect} to={"/Journals/" + item.title.replace(/ /g, "+") + "/" + item.id}><img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" /></Link>

                    : null}
                {this.state.manualLink == item.productType ?
                    <Link onClick={this.handleSelect} to={"/Manuals/" + item.title.replace(/ /g, "+") + "/" + item.id}><img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" /></Link>
                    : null}
                {this.state.encycloLink == item.productType ?
                    <Link onClick={this.handleSelect} to={"/Encyclopedias/" + item.title.replace(/ /g, "+") + "/" + item.id}><img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" /></Link>
                    :
                    null}

                <div style={{ width: '100%' }}>
                    {this.state.journalLink == item.productType ?
                        <Link onClick={this.handleSelect} to={"/Journals/" + item.title.replace(/ /g, "+") + "/" + item.id}> <h2 className="paddingL BookHeading" dangerouslySetInnerHTML={{ __html: item.title }}></h2></Link>
                        :
                        null}
                    {this.state.manualLink == item.productType ?
                        <Link onClick={this.handleSelect} to={"/Manuals/" + item.title.replace(/ /g, "+") + "/" + item.id}> <h2 className="paddingL BookHeading" dangerouslySetInnerHTML={{ __html: item.title }}></h2></Link>
                        : null}
                    {this.state.encycloLink == item.productType ?
                        <Link onClick={this.handleSelect} to={"/Encyclopedias/" + item.title.replace(/ /g, "+") + "/" + item.id}> <h2 className="paddingL BookHeading" dangerouslySetInnerHTML={{ __html: item.title }}></h2></Link>
                        : null}
                    <p className="paddingL BookBody">
                        <div dangerouslySetInnerHTML={{ __html: item.description }} className="SetHfortopic"></div>
                        {this.state.journalLink == item.productType ?
                            <p>
                                <h3 style={{ fontSize: '17px' }} ><span className="TopicLink">Journal</span></h3> <hr className="HrCSS"></hr>
                            </p>
                            : null}
                        {this.state.manualLink == item.productType ?
                            <p>
                                <h3 style={{ fontSize: '17px' }} ><span className="TopicLink">Manual</span></h3> <hr className="HrCSS"></hr>
                            </p>
                            : null}
                        {this.state.encycloLink == item.productType ?
                            <p>
                                <h3 style={{ fontSize: '17px' }} ><span className="TopicLink">Encyclopaedia</span></h3> <hr className="HrCSS"></hr>
                            </p>
                            : null}
                    </p>
                </div>
            </div>
        );
        unSubscribedData = otherSubscribedArray.map((item, key) =>

            <div className="JournalFlex SetHeightfortopic">
                {this.state.journalLink == item.productType ?

                    <Link onClick={this.handleSelect} to={"/Journals/" + item.title.replace(/ /g, "+") + "/" + item.id}><img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" /></Link>

                    : null}
                {this.state.manualLink == item.productType ?
                    <Link onClick={this.handleSelect} to={"/Manuals/" + item.title.replace(/ /g, "+") + "/" + item.id}><img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" /></Link>
                    : null}
                {this.state.encycloLink == item.productType ?
                    <Link onClick={this.handleSelect} to={"/Encyclopedias/" + item.title.replace(/ /g, "+") + "/" + item.id}><img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" /></Link>
                    :
                    null}

                <div style={{ width: '100%' }}>
                    {this.state.journalLink == item.productType ?
                        <Link onClick={this.handleSelect} to={"/Journals/" + item.title.replace(/ /g, "+") + "/" + item.id}> <h2 className="paddingL BookHeading" dangerouslySetInnerHTML={{ __html: item.title }}></h2></Link>
                        :
                        null}
                    {this.state.manualLink == item.productType ?
                        <Link onClick={this.handleSelect} to={"/Manuals/" + item.title.replace(/ /g, "+") + "/" + item.id}> <h2 className="paddingL BookHeading" dangerouslySetInnerHTML={{ __html: item.title }}></h2></Link>
                        : null}
                    {this.state.encycloLink == item.productType ?
                        <Link onClick={this.handleSelect} to={"/Encyclopedias/" + item.title.replace(/ /g, "+") + "/" + item.id}> <h2 className="paddingL BookHeading" dangerouslySetInnerHTML={{ __html: item.title }}></h2></Link>
                        : null}
                    <p className="paddingL BookBody">
                        <div dangerouslySetInnerHTML={{ __html: item.description }} className="SetHfortopic"></div>
                        {this.state.journalLink == item.productType ?
                            <p>
                                <h3 style={{ fontSize: '17px' }} ><span className="TopicLink">Journal</span></h3> <hr className="HrCSS"></hr>
                            </p>
                            : null}
                        {this.state.manualLink == item.productType ?
                            <p>
                                <h3 style={{ fontSize: '17px' }} ><span className="TopicLink">Manual</span></h3> <hr className="HrCSS"></hr>
                            </p>
                            : null}
                        {this.state.encycloLink == item.productType ?
                            <p>
                                <h3 style={{ fontSize: '17px' }} ><span className="TopicLink">Encyclopaedia</span></h3> <hr className="HrCSS"></hr>
                            </p>
                            : null}
                    </p>
                </div>
            </div>
        );


        return (
            <DocumentMeta {...meta}>
                <div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-lg-9">
                                <p className="AllColPadding"><Link to="/PracticeAreas" className="LinkClass" >  All practice areas</Link> > {this.practiceAreaTopic}
                                </p>
                                <div className="margintop">
                                    <br />
                                    <p className="colPadding PublicationTitle"> <h1 style={{ fontFamily: 'franziska-bookitalic', fontSize: '22px', color: '#474747' }}> {this.state.practiceAreaTitle} </h1></p>
                                    <br />
                                </div>
                                {this.state.login && isSubscribe == 1 && subscribedArray.length > 0 ?
                                    <div>
                                        <p className="colPadding PublicationTitle"> Your online publications</p>
                                    </div>
                                    : null}
                                {this.state.login && isSubscribe == 1 && subscribedArray.length > 0 ?
                                    <div className="colPadding margintop" style={{ minWidth: '73%' }}>
                                        {subscribedData}

                                    </div>
                                    : null}
                                {this.state.login && otherSubscribedArray.length > 0 ?
                                    <div>
                                        <p className="colPadding PublicationTitle">Other available publications</p>
                                    </div>
                                    : null}

                                {(this.state.login == true || this.state.login == false) ?
                                    <div>
                                        {(this.state.login == false) ?
                                            <br></br>
                                            :
                                            null
                                        }
                                        <div className="colPadding margintop" style={{ minWidth: '73%' }}>
                                            {unSubscribedData}
                                        </div>
                                    </div>
                                    : null}

                            </div>
                            <div className="col-lg-3">

                                <span className="LinkClass Chtopic" style={{ cursor: 'pointer' }}
                                    onClick={() => this.setState({ showText: !this.state.showText })}>
                                    {
                                        !this.state.Clicked ?
                                            "Change practice area"
                                            :
                                            this.state.practiceAreaTitle.length > 39 ? this.stingBreakLine(this.state.practiceAreaTitle, 37, "...") : this.state.practiceAreaTitle
                                    }
                                </span>

                                {!this.state.showText ?
                                    <i className="fa fa-caret-down caret float-none" style={{ marginLeft: '3%' }}>
                                    </i>
                                    :
                                    <i className="fa fa-caret-up caret float-none" style={{ marginLeft: '3%' }}>
                                    </i>
                                }

                                <div style={this.state.showText ? Setborder : null}>
                                    {this.state.showText ?
                                        (this.state.practiceAreasddlList && this.state.practiceAreasddlList.length > 0) && this.state.practiceAreasddlList.map((data) => {

                                            return (
                                                <div onClick={this.changeEvent} id={data.id} className="HoverList">
                                                    <span style={{ fontSize: '14px', cursor: 'pointer' }} id={data.id} > {data.topic}</span>
                                                    <br />
                                                </div>
                                            )

                                        })
                                        :
                                        null
                                    }
                                </div>


                            </div>

                        </div>


                        <div className="row colPadding margintop">

                            <div className="col-lg-3" style={{ display: 'none' }}>
                                {!this.state.login ?
                                    <div>
                                        <div className="TopicBorder BGGrey" id="Subcribeto" style={{ borderTop: '2px solid #CCCCCC' }}>
                                            <p className="paddingL fontbold margintop SetPaddingforP" style={{ marginBottom: '4%' }}> Subscribe to this practice area </p>
                                        </div>
                                        <div className="TopicBorder" id="TopicLinkmenu">
                                            <p className="paddingL fontbold" style={{ lineHeight: '3', marginBottom: '3%' }}>Interested in a subscription?
                                                    <Link to="/ContactSales" variant="secondary" style={{ marginTop: '3%', textAlign: 'center' }} className="Modalbutton Setwdth HoverUnderline">  <strong> Contact our sales team</strong> </Link>
                                            </p>
                                        </div>
                                    </div>
                                    : null}
                            </div>

                        </div>


                        <div className="White">
                        </div>
                        <div className="White">
                        </div>

                    </div>
                </div>
            </DocumentMeta >
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Topics/TopicDescription.jsx